import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Space, theme } from "antd";
import React, { useEffect } from "react";
import { LIST_UNITS, requiredItem } from "../../../constants/constants";
import { filterOption, formatInputNumber, parseInputNumber } from "../../../utils/funcHelper";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";

const ModalProductInfo = ({ visible, onCancel, onSave, data, title, type }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };

    const handleFinish = (values) => {
        if (type === "ADD") {
            onSave(values);
        } else {
            let tempData = { ...values };
            tempData.id = data.id;
            onSave(tempData);
        }
    };

    useEffect(() => {
        if (type === "EDIT") {
            form.setFieldsValue({
                ...data
            });
        } else {
            form.resetFields();
        }
    }, [data, type, visible]);

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={'50%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="product-info-form" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    {/* Tên sản phẩm */}
                    <Col span={18}>
                        <Form.Item
                            label="Tên sản phẩm"
                            name="name"
                            rules={requiredItem}
                        >
                            <Input placeholder="Nhập tên sản phẩm" />
                        </Form.Item>
                    </Col>

                    {/* Chọn đơn vị tính */}
                    <Col span={6}>
                        <Form.Item
                            label="Đơn vị tính"
                            name="unit"
                            rules={requiredItem}
                        >
                            <Select
                                showSearch
                                placeholder="Chọn đơn vị tính"
                                filterOption={filterOption}
                                options={LIST_UNITS}
                                style={{ width: '100%', height: 40 }}
                            />
                        </Form.Item>
                    </Col>

                    {/* Giá nhập */}
                    <Col span={12}>
                        <Form.Item
                            label="Giá nhập (VNĐ)"
                            name="cost_price"
                            rules={requiredItem}
                        >
                            <InputNumber
                                className="input-number-cus-ant cus-height-40"
                                min={0}
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                                placeholder="Nhập giá nhập"
                            />
                        </Form.Item>
                    </Col>

                    {/* Giá bán */}
                    <Col span={12}>
                        <Form.Item
                            label="Giá bán (VNĐ)"
                            name="sell_price"
                            rules={requiredItem}
                        >
                            <InputNumber
                                className="input-number-cus-ant cus-height-40"
                                min={0}
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                                placeholder="Nhập giá bán"
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel} icon={<CloseOutlined />}>
                            Đóng
                        </Button>
                        <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    );
};

export default React.memo(ModalProductInfo);